export default "static/src/images/docinti/ec-italia-logo.jpg";